module.exports = __webpack_public_path__ + "media/images/pers-81e4255eb321a6a07a92489ea8a41386.png";